export default __webpack_public_path__ + "static/media/37.5f024846.jpg";